export const ROUTES = {
  HOME: '/',
  AUTH: '/auth',
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  RESET_PASSWORD: '/auth/reset-password',
  ACCOUNT_RECOVERY: '/auth/account-recovery',
  LOGIN_WITHOUT_PASSWORD: '/auth/login-without-password',

  DONOR_APPOINTMENTS: '/donor/appointments',
  DONOR_HEALTH_HISTORY: '/donor/health-history',
  DONOR_LOYALTY_AUTH: '/loyalty-auth',

  DONATE: '/donate',
  DONATE_NAV_NOT_CONFIGURED: '/donate/not-available',
  DONATE_NEAR_YOU: '/donate-near-you',
  DONATE_NEAR_YOU_RESULTS: '/donate-near-you/results',

  DONATE_SPONSOR: '/search-by-sponsor',
  DONATE_SPONSOR_RESULTS: '/search-by-sponsor/results',
  DONATE_EVENT: '/search-by-event',
  DONATE_PRIVATE_DRIVES: '/private-drives',
  DONATE_DONOR_CENTERS: '/search-by-donor-centers',
  DONATE_DONOR_CENTERS_CALENDAR: '/search-by-donor-centers/calendar',

  DONATE_ZIP_CODE: '/search-by-zip-code',
  DONATE_ZIP_CODE_RESULTS: '/search-by-zip-code/results',

  DONATE_CITY: '/search-by-city',
  DONATE_CITY_RESULTS: '/search-by-city/results',

  SCHEDULE_DONATION: '/schedule-donation',

  GUEST_CONFIRM_APPOINTMENT: '/guest/confirm-appointment',

  CHAIRPERSON: '/chairperson',
  CHAIRPERSON_LOGIN: '/chairperson/login',
  CHAIRPERSON_DASHBOARD: '/chairperson/dashboard',
  CHAIRPERSON_SCHEDULE_DRIVE: '/chairperson/schedule-drive/:driveId',
  CHAIRPERSON_DRIVE_RESULTS: '/chairperson/drive-results/:driveId',
  CHAIRPERSON_DRIVE_DONORS: '/chairperson/drive-donors/:driveId',
  CHAIRPERSON_DRIVE_DONORS_EMAIL_COMPOSE:
    '/chairperson/drive-donors/:driveId/email/compose',
  CHAIRPERSON_DRIVE_DONORS_EMAIL_REVIEW:
    '/chairperson/drive-donors/:driveId/email/review',
  CHAIRPERSON_RESET_PASSWORD: '/chairperson/reset-password',
  CHAIRPERSON_ACCOUNT_RECOVERY: '/chairperson/account-recovery',
}
